'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setFields = exports.setPageView = exports.setGaUserId = exports.initGA = undefined;

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initGA = exports.initGA = function initGA(trackingID) {
    _reactGa2.default.initialize(trackingID, {
        debug: true,
        testMode: process.env.NODE_ENV === 'test',
        gaOptions: {
            siteSpeedSampleRate: 100,
            cookieDomain: 'auto'
        }
    });
};
var setGaUserId = exports.setGaUserId = function setGaUserId(userID) {
    return _reactGa2.default.set({ userId: userID });
};
var setPageView = exports.setPageView = function setPageView() {
    return _reactGa2.default.pageview(window.location.pathname);
};
var setFields = exports.setFields = function setFields(fields) {
    return _reactGa2.default.set(fields);
};
//# sourceMappingURL=ga-tracking.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/helpers/ga-tracking/ga-tracking.js
// module id = 1994
// module chunks = 0